module.exports = __webpack_public_path__ + "img/Step13.80397e22.png";